import { PRINT_FONT_OPTIONS, DEFAULT_PRINT_FONT_ID, sanitizeStoredFontValue } from "@vet/print-core";

const registered = new Set<string>();

const face = (family: string, src: string, weight: number, style: "normal" | "italic") =>
  `@font-face{font-family:"${family}";src:url("${src}") format("truetype");font-style:${style};font-weight:${weight};font-display:swap;}`;

/** Injects @font-face rules for UI samples (e.g. "Aa" font previews). The preview iframe loads fonts itself. */
export function ensureCssFontFace(fontId: string | null | undefined): void {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  const id = sanitizeStoredFontValue(fontId);
  const font = PRINT_FONT_OPTIONS.find((f) => f.id === id) ?? PRINT_FONT_OPTIONS.find((f) => f.id === DEFAULT_PRINT_FONT_ID);
  if (!font || registered.has(font.id)) return;
  registered.add(font.id);
  if (font.systemOnly || !font.files) return;
  const { regular, bold, italic, boldItalic } = font.files;
  const style = document.createElement("style");
  style.setAttribute("data-font-id", font.id);
  style.textContent = [
    face(font.cssFamily, regular, 400, "normal"),
    face(font.cssFamily, bold, 700, "normal"),
    italic ? face(font.cssFamily, italic, 400, "italic") : "",
    boldItalic ? face(font.cssFamily, boldItalic, 700, "italic") : "",
  ].join("\n");
  document.head.appendChild(style);
}
